module.exports = __webpack_public_path__ + "96aca867e8aa7e9663db12c84f8e73d3.pdf";